import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import Breadcrumb from 'component/Breadcrumb'

import ContentHeader from 'component/utils/ContentHeader'
import * as gamaActions from 'action/gama'
import Form from 'component/newGama/EditForm'

import { ToastContainer } from 'react-toastify'

import SuccessModal from 'component/Modal/SuccessModal'
import ErrorModal from '../../components/Modal/ErrorModal'

class GamaEdit extends Component {
  state = {
    loadedGama: true,
    showSuccess: false,
    showErrorModal: false,
    showSaveErrorModal: false,
    errorMessage: '',
  }

  renderBreadcrumb = () => {
    const { translate } = this.props

    const steps = [
      { link: '/', title: translate('mobile.home') },
      { title: translate('mobile.irc-configurations') },
      { title: translate('gama') },
    ]

    return <Breadcrumb steps={steps} />
  }

  componentWillUnmount() {
    const {resetGama} = this.props
    resetGama()

  }

  handleSubmit = (args) => {
    const { auth, fetchSectionsSuccess, updateGama } = this.props
    args.cdLdap = auth.user.username
    args.dsLdap = auth.user.fullName
    updateGama(auth.user.dsToken, { ...args }).then((resp) => {
      if (resp.cdStatus === 200) {
        fetchSectionsSuccess({ ...args, idGama: resp.data.idGama })
        this.setState({ showSuccess: true })
      } else {
        /* istanbul ignore else */
        if (resp.message && resp.message.dsMessage) {
          this.setState({showSaveErrorModal: true, errorMessage: resp.message.dsMessage})
        } else {
          this.setState({showSaveErrorModal: true, errorMessage: ''})
        }
      }
    })
  }

  render() {
    const { translate, auth, savedGama, error, fetchSections } = this.props
    const { loadedGama, showSuccess } = this.state

    return (
      <div className='irc'>
        <ContentHeader>{translate('irc.gama.title')}</ContentHeader>

        {showSuccess && (
          <SuccessModal
            handleClose={() => this.setState({ showSuccess: false })}
            msg={translate('irc.gama.onSubmitSuccess')}
            size='md'
            t={translate}
          />
        )}

        {loadedGama && (
          <Form
            translate={translate}
            onSubmit={this.handleSubmit}
            records={''}
            auth={auth}
            savedGama={savedGama}
            initialValues={savedGama}
            error={error}
            fetchSections={fetchSections}
          />
        )}
        <ToastContainer newestOnTop />
        {this.state.showSaveErrorModal &&  <ErrorModal fillButton center handleClose={() => this.setState({showSaveErrorModal: false}) } size="sm" buttonText="OK" msg={this.state.errorMessage || translate('lmexpress.parameter.update-fail')} t={translate} />}
        {this.state.showErrorModal && <ErrorModal fillButton center handleClose={() => this.setState({showErrorModal: false})} size="sm" buttonText="OK" msg={translate('params.supply.notFound')}  t={translate} /> }
      </div>
    )
  }
}

GamaEdit.propTypes = {
  auth: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  fetchSections: PropTypes.func.isRequired,
  fetchSectionsSuccess: PropTypes.func.isRequired,
  savedGama: PropTypes.object,
  error: PropTypes.object,
  updateGama: PropTypes.func.isRequired,
  resetGama: PropTypes.func.isRequired
}

const mapStateToProps = /* istanbul ignore next */ ({ gamaReducer }) => ({
  savedGama: gamaReducer.get.record,
  error: gamaReducer.save.error,
})

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(gamaActions, dispatch)

/* istanbul ignore next */
const GamaEditTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(GamaEdit)

/* istanbul ignore next */
export default connect(mapStateToProps, mapDispatchToProps)(GamaEditTranslated)

export { GamaEdit }
